import styled from 'styled-components';

export const NavArrowStyled = styled.div<{ hide: boolean; direction?: string }>`
  position: absolute;
  width: 36px;
  height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 22px;
  background-color: #fff;
  transition: background-color 0.2s ease-in-out;
  display: none;
  margin-bottom: 18px;
  align-items: center;
  justify-content: center;
  outline: none;

  @media only screen and (min-width: 768px) {
    ${({ hide }) => (hide ? `display: none;` : 'display: flex;')}
  }

  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    outline-offset: 2px;
  }

  ${({ direction }) =>
    direction === 'left' ? `left: 0; transform: rotate(90deg);` : 'right: 0;transform: rotate(270deg);'}

  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;
